export default "__VITE_ASSET__DN8ydLR4__"